import * as React from 'react';
import './index.scss';
import { Modal, Popover } from 'antd';
import { logout } from '../../model/api';
import Logo2 from '../logo2';

export default class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showLogoutConfirm: false,
            // optOpen: false, // 顶部的操作popover显隐控制
        }

        this.handleLogout = this.handleLogout.bind(this);
    }

    handleLogout() {
        logout();
        this.setState({ user: null, showLogoutConfirm: false });
        this.props.history.push('/login')
    }

    changeOrderType(value) {
        const { history, type } = this.props
        if (type === "order" && value === 'meeting') {// 会议订餐
            history.push('/meeting')
        }
        if (type === "meeting" && value === 'order') {// 工作订餐
            history.push('/order')
        }
        // this.setState({ optOpen: false })
    }

    popoverContent() {
        const { type } = this.props
        return <div>
            <div className='order-popover-item' onClick={() => this.setState({ showLogoutConfirm: true })}>退出登录</div>
            <div className='order-popover-item' onClick={() => this.changeOrderType("meeting")} style={{ backgroundColor: type === "meeting" ? 'rgba(186, 186, 186, 0.5)' : 'none' }}>会议订餐</div>
            <div className='order-popover-item' onClick={() => this.changeOrderType("order")} style={{ backgroundColor: type === "order" ? 'rgba(186, 186, 186, 0.5)' : 'none' }}>工作订餐</div>
        </div>
    }

    render() {
        // const { optOpen } = this.state;
        return <> <div className='order-top'>
            <div className='order-logo'><Logo2 /></div>
            <Popover
                placement="bottomLeft"
                className='opt-popover'
                // open={optOpen}
                content={this.popoverContent()}
                trigger={['click']}
            >
                <div
                    className='order-logout'
                    // onClick={() => this.setState({ optOpen: true })}
                >
                    <i className='fa fa-ellipsis-h' />
                </div>
            </Popover>
        </div>
            <Modal
                title="退出确认"
                centered={true}
                open={this.state.showLogoutConfirm}
                onOk={this.handleLogout}
                onCancel={() => this.setState({ showLogoutConfirm: false })}
                okText="退出">
                <div>确认退出登录么？</div>
            </Modal>
        </>
    }

}